module.exports = __webpack_public_path__ + "img/6525.856edda5.jpg";